module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout"
  }, [_c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "300"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Precauções")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        É necessário desocupar o local no intervalo de tempo entre seis e oito horas. - Aguardar rigorosamente o tempo definido."), _c('br'), _c('br'), _vm._v("\n        Crianças, pessoas idosas ou alérgicas, deverão observar um prazo específico, ou solicitar orientação médica."), _c('br'), _vm._v("\n        - Evite lavar os locais nos 03 primeiros dias após a aplicação, bem como usar produtos à base de pinho, que podem neutralizar a ação dos inseticidas."), _c('br'), _c('br'), _vm._v("\n        É possível o surgimento de insetos nos primeiros dias após a aplicação (o inseticida possui ação desalojante). Aguarde de 15 a 20 dias para a avaliação dos serviços."), _c('br'), _c('br'), _vm._v("\n        - Insetos em geral têm hábitos noturnos; evite deixar restos de alimentos acessíveis a eles durante a noite."), _c('br'), _vm._v("\n        - Em caso de nova infestação, durante o período de garantia, basta telefonar e agendar aplicação de reforço, sem qualquer custo adicional.\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-checkbox', {
    attrs: {
      "color": "green"
    },
    model: {
      value: (_vm.aware),
      callback: function($$v) {
        _vm.aware = $$v
      },
      expression: "aware"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("Estou ciente")])])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-hotsite",
    attrs: {
      "loading": _vm.loadingOrderRequest,
      "disabled": !_vm.loadingOrderRequest && !_vm.aware,
      "flat": "flat"
    },
    on: {
      "click": _vm.requestOrder
    },
    nativeOn: {
      "click": function($event) {
        _vm.loader = 'loading'
      }
    }
  }, [_vm._v("\n           confirmar pedido\n         ")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-slide-x-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [(_vm.client !== null) ? _c('div', {
    staticClass: "box-want"
  }, [_c('div', {
    staticClass: "description"
  }, [_c('strong', [_vm._v("  " + _vm._s(_vm.client.name) + " ")]), _vm._v(", \n      seu condomínio passará por "), _c('strong', [_vm._v(" \n      " + _vm._s(_vm.client.category) + " ")]), _vm._v(" pela empresa "), _c('strong', [_vm._v(" " + _vm._s(_vm.client.business) + " ")]), _vm._v(", conforme agendamento abaixo.\n    ")]), _vm._v(" "), _c('v-layout', {
    staticClass: "realization-date pt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left"
  }, [_c('strong', [_c('v-icon', [_vm._v("event")]), _vm._v(" Data:\n      ")], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [(_vm.item.dates.length > 0) ? _c('v-select', {
    staticClass: "pt-0 hour-select",
    attrs: {
      "items": _vm.item.dates,
      "hide-details": "",
      "single-line": "",
      "prepend": "",
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('span', {
          staticClass: "date"
        }, [_vm._v(_vm._s(_vm._f("formatDate")(data.item)))])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('div', {
          key: JSON.stringify(data.formatDate)
        }, [_vm._v("\n          " + _vm._s(_vm._f("formatDate")(data.item)) + "\n        ")])]
      }
    }], null, false, 831896227),
    model: {
      value: (_vm.dateChoosen),
      callback: function($$v) {
        _vm.dateChoosen = $$v
      },
      expression: "dateChoosen"
    }
  }) : _c('div', {}, [_vm._v("\n        " + _vm._s(_vm._f("formatDate")(_vm.item.dateSchedule)) + "\n      ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "realization-date pt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left"
  }, [_c('strong', [_c('v-icon', [_vm._v("business")]), _vm._v(" Unidade:\n      ")], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [(_vm.unity.length !== 1) ? _c('v-select', {
    staticClass: "pt-0 hour-select",
    attrs: {
      "items": _vm.client.unity,
      "hide-details": "",
      "single-line": "",
      "prepend": "",
      "append-icon": "",
      "bottom": ""
    },
    model: {
      value: (_vm.unityChoosen),
      callback: function($$v) {
        _vm.unityChoosen = $$v
      },
      expression: "unityChoosen"
    }
  }) : _c('div', {}, [_vm._v("\n        " + _vm._s(_vm.client.unity[0]) + "\n      ")])], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-2": ""
    }
  }, [_c('hr')])], 1), _vm._v(" "), _c('div', {
    staticClass: "more-description"
  }, [_vm._v("\n    Esse é o momento ideal para agendar o serviço.\n  ")]), _vm._v(" "), _c('v-layout', {
    staticClass: "realization-date mt-2 mb-2 pa-0",
    attrs: {
      "slot": "activator",
      "row": "",
      "wrap": ""
    },
    slot: "activator"
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.item.priceTable,
      "item-text": "description",
      "item-value": "provider",
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.itemChoosen),
      callback: function($$v) {
        _vm.itemChoosen = $$v
      },
      expression: "itemChoosen"
    }
  })], 1)], 1), _vm._v(" "), (_vm.price !== _vm.priceRef) ? [_c('div', {
    staticClass: "price"
  }, [_c('div', {
    staticClass: "real-price"
  }, [_c('div', {}, [_vm._v("\n          De " + _vm._s(_vm._f("currency")(_vm.priceRef)) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "discount-price"
  }, [_c('span', [_vm._v("Por ")]), _vm._v(" " + _vm._s(_vm._f("currency")(_vm.price)) + "\n      ")])])] : [_c('div', {
    staticClass: "price"
  }, [_c('div', {
    staticClass: "discount-price"
  }, [_vm._v("\n        " + _vm._s(_vm._f("currency")(_vm.price)) + "\n      ")])])], _vm._v(" "), _c('v-layout', {
    staticClass: "realization-date mt-3 pa-0 mb-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('strong', [_c('v-icon', [_vm._v("access_time")]), _vm._v(" Escolha um horário:\n      ")], 1)]), _vm._v(" "), _c('v-flex', [_c('v-select', {
    staticClass: "pt-0 hour-select",
    attrs: {
      "items": _vm.avaliableSchedule,
      "hide-details": "",
      "single-line": "",
      "prepend": "",
      "append-icon": "",
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('span', {
          staticClass: "time"
        }, [_vm._v(_vm._s(_vm._f("time")(data.item)))])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('div', {
          key: JSON.stringify(data.item)
        }, [_vm._v("\n            " + _vm._s(_vm._f("time")(data.item)) + "\n          ")])]
      }
    }], null, false, 1656706560),
    model: {
      value: (_vm.timeChoosen),
      callback: function($$v) {
        _vm.timeChoosen = $$v
      },
      expression: "timeChoosen"
    }
  })], 1)], 1), _vm._v(" "), (_vm.paymentsViewModel.length > 0) ? [_c('v-layout', {
    staticClass: "realization-date pa-0 mb-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left"
  }, [_c('strong', [_c('v-icon', [_vm._v("payment")]), _vm._v(" Pagamento:\n        ")], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    staticClass: "text-xs-center",
    attrs: {
      "items": _vm.paymentsViewModel,
      "hide-details": "",
      "item-text": "description",
      "item-value": "id",
      "single-line": "",
      "prepend": "",
      "bottom": ""
    },
    model: {
      value: (_vm.paymentChoosen),
      callback: function($$v) {
        _vm.paymentChoosen = $$v
      },
      expression: "paymentChoosen"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center alert--text"
  }, [_vm._v("\n        Pagamento realizado na visita\n      ")])], 1)] : _vm._e(), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "green",
      "hide-details": "",
      "light": ""
    },
    model: {
      value: (_vm.acceptance),
      callback: function($$v) {
        _vm.acceptance = $$v
      },
      expression: "acceptance"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("li e aceito: "), _c('CondicoesDeUso')], 1)]), _vm._v(" "), (_vm.itemActive) ? _c('v-btn', {
    staticClass: "btn-hotsite",
    attrs: {
      "large": "",
      "block": ""
    },
    on: {
      "click": _vm.openDialog
    }
  }, [_vm._v("\n    Confirmar pedido\n    "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)]) : _c('v-btn', {
    staticClass: "btn-hotsite",
    attrs: {
      "large": "",
      "disabled": true,
      "block": ""
    }
  }, [_vm._v("\n    Oferta expirada\n    "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 2) : _vm._e()]), _vm._v(" "), _c('v-slide-y-reverse-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [(!_vm.loadingCheckout) ? _c('Feedback', {
    staticClass: "feedback-btn",
    attrs: {
      "token": _vm.token
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b879125","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hotsite/Checkout.vue
// module id = 739
// module chunks = 9